module.exports = {
  message: {
    test: '测试',
    main:'首页',
    about:'关于',
    works:'作品',
    build:'建筑',
    indoor:'室内',
    design:'设计',
    vision:'视觉',
    report:'媒体',
    news:'新闻',
    publication:'刊物',
    contact:'联系',
    generalEnquiries:'一般事务咨询',
    marketing: '市场推广&媒体推广咨询',
    career: '职业咨询',
    all:'全部',
    private:'私有',
    public:'公共',
    down:'下滑',
    more:'查看详情',
    video:'视频',
    infro:'信息',
    awards:'奖项'

  }
}
